import { render } from "./ContractList.vue?vue&type=template&id=39bafa39"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"
script.render = render

export default script